import nr from "nr";
import frozenAxios from "@/api/frozenAxios";

const api = nr.loadScript("api-common");
const memory = nr.loadScript("memory");
const urlBase = memory.urlBase;
const getData = api.getCommonData;
const editUrl = urlBase + "editor/data/hns/";
const transUrl = urlBase + "editor/weixin/";
const request = api.request;

export function getAuthState(param, success) {
  if (param.tag) {
    return getData(param.url + "&tag=" + param.tag, {}, success);
  }
  getData(param.url + "&tag=11", {}, success);
}
export function getWeixinAuthResult(authorizeUuid, success) {
  getData(editUrl + "getWeixinAuthResult", { uuid: authorizeUuid }, success);
}
export function getWeixinAuthCodeUuid(openid, success) {
  getData(editUrl + "getWeixinAuthCodeUuid", { openid: openid }, success);
}
export function transAccount(callBack_id, isMini, success) {
  getData(
    transUrl + "queRengengai",
    { callBack_id: callBack_id, isMini: isMini },
    success
  );
}
export function authorizationNeed(success) {
  getData(urlBase + "bind/weixin/authorizationNeed", {}, success);
}
export function transfer(uuid, flag, type, success) {
  getData(
    urlBase + "bind/weixin/transfer",
    { uuid: uuid, flag: flag, type: type },
    success
  );
}
export function getWeixinAuthCode(uuid, success) {
  getData(editUrl + "getWeixinAuthCode", { uuid: uuid }, success);
}

// 是否关注服务号
export function getUserIsSUbXinBang(success, fail) {
  request({
    url: memory.rootUrl.main + "nr/user/info/getUserIsSUbXinBang",
    method: "GET",
    success: success,
    error: fail,
  });
}

export const getSqWechatLink = (params) => {
  return frozenAxios.post(
    "https://gw.newrank.cn/api/bridge/nr/bridge/chat/message/getLink",
    params
  );
};

/** 个人中心-可结款金额 */
export function getPaymentAmont() {
  return frozenAxios.get(
    `/api/path/xdnphb/ade/v1/api/tixian/getMoneyDetail`
  );
}



// WEBPACK FOOTER //
// ./src/assets/js/api/author.js